module.exports = __webpack_public_path__ + "static/media/deal-bg.7cd1a538.png";